import { Navigate } from 'react-router-dom';
import { homeRoute } from '@/config/homeRoute';
import { useShellIdentity } from '@/components/shell/useShellIdentity';

/**
 * An address nothing answers to goes to the signed-in role's own home — the
 * receptionist's desk, the doctor's day — never to the generic dashboard a
 * front desk has no permission to read (it painted a page of zeros).
 */
export function UnknownRouteHome() {
  const { surface } = useShellIdentity();
  return <Navigate to={homeRoute(surface)} replace />;
}
